(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const burger = document.querySelector('.burger');
  const nav = document.getElementById('nav-principale');
  const list = nav && nav.querySelector('.nav-links');
  const mq = window.matchMedia('(max-width:1100px)');

  if (burger && nav && list) {
    const setOpen = (open) => {
      list.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      // ferme aussi tous les panneaux méga ouverts
      if (!open) {
        list.querySelectorAll('.a-sous.has-children > a[aria-expanded="true"]')
            .forEach(a => a.setAttribute('aria-expanded', 'false'));
      }
    };

    // Bouton burger : ouvre/ferme le tiroir (stopPropagation pour ne pas
    // déclencher la fermeture « clic extérieur » ci-dessous)
    burger.addEventListener('click', (e) => {
      e.stopPropagation();
      setOpen(!list.classList.contains('open'));
    });

    // Clic dans le tiroir : retour / déclencheur méga (mobile) / lien normal
    list.addEventListener('click', (e) => {
      // 1) Bouton « retour » : referme le panneau méga
      const back = e.target.closest('.menu-back');
      if (back) {
        const sm = back.closest('.sous-menu');
        const trigger = sm && sm.parentElement.querySelector(':scope > a');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        return;
      }
      const a = e.target.closest('a');
      if (!a) return;
      const li = a.closest('li.a-sous.has-children');
      const isTrigger = li && a.parentElement === li;          // <a> déclencheur direct
      if (isTrigger && mq.matches) {
        e.preventDefault();
        e.stopPropagation();
        const open = a.getAttribute('aria-expanded') === 'true';
        // un seul panneau ouvert à la fois
        list.querySelectorAll('.a-sous.has-children > a[aria-expanded="true"]')
            .forEach(x => x.setAttribute('aria-expanded', 'false'));
        if (!open) a.setAttribute('aria-expanded', 'true');
        return;
      }
      setOpen(false);   // lien normal : navigation + fermeture du tiroir
    });

    // Activation clavier de la barre retour (div, pas de <button> natif)
    list.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        const back = e.target.closest('.menu-back');
        if (back) { e.preventDefault(); back.click(); }
      }
    });

    // Fermeture : touche Échap
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') setOpen(false);
    });

    // Fermeture : clic en dehors du tiroir (le burger est hors du nav)
    document.addEventListener('click', (e) => {
      if (list.classList.contains('open') && !nav.contains(e.target)) {
        setOpen(false);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
